import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { OperateursService } from 'src/app/data/intervenant/services/operateurs/operateurs.service';

import { NavigationContext } from 'src/app/core/services/config/app.settings';

@Component({
    selector: 'app-operateurs',
    templateUrl: './operateurs.component.html',
    styleUrls: ['./operateurs.component.scss'],
    imports: [RouterOutlet],
    standalone: true
})
export class OperateursComponent implements OnInit, OnDestroy {
    /**
     * Operateurs service
     */
    operateursService = inject(OperateursService);

    /**
     * Route
     */
    route = inject(ActivatedRoute);

    /**
     * Router
     */
    router = inject(Router);

    /**
     * On init component
     */
    ngOnInit() {
        const idOperateur = this.route.snapshot.paramMap.get('idOperateur');

        if (idOperateur && Number(idOperateur)) {
            this.operateursService.setIdOperateur(Number(idOperateur));
            NavigationContext.set('idOperateur', Number(idOperateur));
            return;
        }

        if (!this.operateursService.idOperateur()) {
            this.router.navigate(['recherche-affilie'], { relativeTo: this.route.parent });
        }
    }

    /**
     * On destroy component
     */
    ngOnDestroy() {
        this.operateursService.setIdOperateur(null);
        NavigationContext.set('idOperateur', undefined);
    }
}
